import { Component, OnInit, Input } from '@angular/core';
import {
  CREATE_SHOPPING_PRODUCT,
  REMOVE_PRODUCT,
} from 'src/environments/api-path';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Subject, of } from 'rxjs';
import { SubSink } from 'subsink';
import { Router } from '@angular/router';
import { RequestService } from 'src/app/services/http/request.service';
import { SnackbarService } from 'src/app/services/snackbar/snackbar.service';
import { delay, takeUntil } from 'rxjs/operators';
import { ShoppingListPopUpComponent } from 'src/app/shared-component/shopping-list-pop-up/shopping-list-pop-up.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-single-product',
  templateUrl: './single-product.component.html',
  styleUrls: ['./single-product.component.scss'],
})
export class SingleProductComponent implements OnInit {
  @Input('product') product;
  @Input('bstCheck') bstCheck;

  calls = new Subject();

  addOrRemove: boolean;
  @Input() title: string;
  unsubscribe = new SubSink();
  arr = [44, 31];

  constructor(
    private auth: AuthService,
    private router: Router,
    private request: RequestService,
    private snack: SnackbarService,
    private dialog: MatDialog
  ) {}
  ngOnInit(): void {
    console.log('this is setup');

    // this.addOrRemove = this.checkProductInList(this.product['id']);
  }

  service = {
    getData: () => of(!this.addOrRemove).pipe(delay(500)),
  };

  click(id) {
    this.checkLogin(id);
    this.calls.next(true);
    this.service
      .getData()
      .pipe(takeUntil(this.calls))
      .subscribe((res) => {
        this.addOrRemove = !this.addOrRemove;
        if (this.addOrRemove === true) {
          this.addToShoppingList(id);
        } else {
          this.removeFromShoppingList(id);
        }
      });
  }

  checkLogin(id) {
    if (!this.auth.isAuthenticated()) {
      this.router.navigate(['/login']);
      return;
    }
    // this.addToShoppingList(id);
  }
  addToShoppingList(id) {
    this.unsubscribe.add(
      this.request.POST(CREATE_SHOPPING_PRODUCT, { product_id: id }).subscribe(
        (res) => {
          console.log(res);
          this.snack.notify(`Saved to ${res['shopping_list_name']}`, 1);
        },
        (err) => console.log(err)
      )
    );
  }
  removeFromShoppingList(id) {
    const url = REMOVE_PRODUCT + id;
    this.unsubscribe.add(
      this.request.DELETE(url, {}).subscribe(
        (response) => {
          this.snack.notify(
            `Removed from ${response['shopping_list_name']}`,
            1
          );
        },
        (err) => {}
      )
    );
  }

  checkProductInList(id) {
    for (let index = 0; index < this.arr.length; index++) {
      if (this.arr[index] == id) return true;
    }
  }
  openDialog(product) {
    console.log(product);

    const dialogRef = this.dialog.open(ShoppingListPopUpComponent, {
      data: product,
      width: '400px',
    });
    dialogRef.afterClosed().subscribe((result) => {
      // this._fetchData();

      window.location.reload();
      if (result.close === true) {
      }
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe.unsubscribe();
  }
}
